// 公共版本号配置

const FJVersionConfig = {
    staticPathVersion: '1.0.16', // 静态资源版本号 如headerLinkShowListJsonPath文件请求
};
export default FJVersionConfig;
